
import { defineComponent, PropType } from "vue";
import { BannerItem, FALLBACK_BANNER } from "../services/banner";

export default defineComponent({
  name: "BannerArtwork",
  props: {
    banner: {
      type: Object as PropType<BannerItem>,
      required: true,
    },
  },
  setup() {
    const handleImageError = (event: Event) => {
      const image = event.currentTarget as HTMLImageElement;
      if (image.src !== FALLBACK_BANNER.imageUrl) {
        image.src = FALLBACK_BANNER.imageUrl;
      }
    };
    return { handleImageError };
  },
});
